import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesClaimCountWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.claim-count",
  name: "Expense claims",
  description: "Expense claims for the selected dashboard period.",
  apps: [
    "home",
    "expenses",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "expense_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Claims",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 84,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
